import React, {useEffect, useState} from 'react';
import {
    Box,
    Button,
    Chip,
    Divider,
    List,
    ListItem,
    ListItemText,
    Paper,
    Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import {Link as RouterLink} from 'react-router-dom';
import axios from 'axios';
import {SURVEYATORIUM_API_URL} from '../api';

const Dashboard = () => {
    const [surveys, setSurveys] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchSurveys = async () => {
            try {
                const response = await axios.get(`${SURVEYATORIUM_API_URL}/surveys/`);
                setSurveys(response.data);
            } catch (err) {
                setError('Failed to fetch surveys.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchSurveys();
    }, []);

    if (loading) return <Typography>Loading surveys...</Typography>;
    if (error) return <Typography color="error">{error}</Typography>;

    return (
        <Paper elevation={3} sx={{p: 3}}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h4">Your Surveys</Typography>
                <Button
                    variant="contained"
                    startIcon={<AddIcon/>}
                    component={RouterLink}
                    to="/survey/new"
                >
                    New Survey
                </Button>
            </Box>
            <Divider/>
            <List>
                {surveys.length > 0 ? (
                    surveys.map((survey) => (
                        <ListItem
                            key={survey.id}
                            button
                            component={RouterLink}
                            to={`/survey/${survey.id}`}
                            divider
                        >
                            <ListItemText
                                primary={survey.title}
                                secondary={`Last updated: ${new Date(survey.updated_at).toLocaleString()}`}
                            />
                            <Chip
                                label={survey.status}
                                color={survey.status === 'DRAFT' ? 'primary' : 'success'}
                                size="small"
                            />
                        </ListItem>
                    ))
                ) : (
                    <Typography sx={{mt: 2, textAlign: 'center'}}>
                        You have not created any surveys yet.
                    </Typography>
                )}
            </List>
        </Paper>
    );
};

export default Dashboard;